module.exports = __webpack_public_path__ + "img/bargains_active.f3e8331.svg";